//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTextfieldBasic from './demos/DemoTextfieldBasic.vue'
import DemoTextfieldDense from './demos/DemoTextfieldDense.vue'
import DemoTextfieldVariant from './demos/DemoTextfieldVariant.vue'
import DemoTextfieldState from './demos/DemoTextfieldState.vue'
import DemoTextfieldCounter from './demos/DemoTextfieldCounter.vue'
import DemoTextfieldClearable from './demos/DemoTextfieldClearable.vue'
import DemoTextfieldCustomColors from './demos/DemoTextfieldCustomColors.vue'
import DemoTextfieldIcons from './demos/DemoTextfieldIcons.vue'
import DemoTextfieldPrefixesAndSuffixes from './demos/DemoTextfieldPrefixesAndSuffixes.vue'
import DemoTextfieldSingleLine from './demos/DemoTextfieldSingleLine.vue'
import DemoTextfieldValidation from './demos/DemoTextfieldValidation.vue'
import DemoTextfieldValidationOnBlur from './demos/DemoTextfieldValidationOnBlur.vue'
import DemoTextfieldIconEvents from './demos/DemoTextfieldIconEvents.vue'
import DemoTextfieldIconSlots from './demos/DemoTextfieldIconSlots.vue'
import DemoTextfieldLabelSlot from './demos/DemoTextfieldLabelSlot.vue'
import DemoTextfieldProgress from './demos/DemoTextfieldProgress.vue'
import DemoTextfieldPasswordInput from './demos/DemoTextfieldPasswordInput.vue'

// code
import {
  textfieldBasic,
  textfieldDense,
  textfieldVariant,
  textfieldState,
  textfieldCounter,
  textfieldClearable,
  textfieldCustomColors,
  textfieldIcons,
  textfieldPrefixesAndSuffixes,
  textfieldSingleLine,
  textfieldValidation,
  textfieldValidationOnBlur,
  textfieldIconEvents,
  textfieldIconSlots,
  textfieldLabelSlot,
  textfieldProgress,
  textfieldPasswordInput,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTextfieldBasic,
    DemoTextfieldDense,
    DemoTextfieldVariant,
    DemoTextfieldState,
    DemoTextfieldCounter,
    DemoTextfieldClearable,
    DemoTextfieldCustomColors,
    DemoTextfieldIcons,
    DemoTextfieldPrefixesAndSuffixes,
    DemoTextfieldSingleLine,
    DemoTextfieldValidation,
    DemoTextfieldValidationOnBlur,
    DemoTextfieldIconEvents,
    DemoTextfieldIconSlots,
    DemoTextfieldLabelSlot,
    DemoTextfieldProgress,
    DemoTextfieldPasswordInput,
  },
  setup() {
    return {
      codeSnippets: {
        textfieldBasic,
        textfieldDense,
        textfieldVariant,
        textfieldState,
        textfieldCounter,
        textfieldClearable,
        textfieldCustomColors,
        textfieldIcons,
        textfieldPrefixesAndSuffixes,
        textfieldSingleLine,
        textfieldValidation,
        textfieldValidationOnBlur,
        textfieldIconEvents,
        textfieldIconSlots,
        textfieldLabelSlot,
        textfieldProgress,
        textfieldPasswordInput,
      },
    }
  },
}
